:host{display:block}.footer-row{display:grid;grid-template-columns:1fr auto;justify-items:right;padding-bottom:15px}.feedback-footer{background-color:#e9ebed;padding:5px;border-radius:4px}
/*# sourceMappingURL=production-workspace.component.css.map */
